import { __assign, __rest } from "tslib";
import React from 'react';
import { DialogActions as MaterialDialogActions, makeStyles, createStyles, } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            '& > .MuiButtonBase-root.MuiButton-outlinedPrimary:last-child': {
                color: theme.palette.primary.contrastText,
                backgroundImage: "linear-gradient(90deg, " + theme.palette.primary.light + ", " + theme.palette.primary.main + ")",
                '&:disabled': {
                    backgroundImage: 'none',
                },
            },
        },
    });
});
export var DialogActions = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useStyles();
    return (React.createElement(MaterialDialogActions, __assign({ classes: classes }, props), children));
};
//# sourceMappingURL=DialogActions.js.map